/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OnboardedUser } from '../../models/onboarded-user';

export interface GetAllServiceOnboardedUsers$Params {

/**
 * The service uid
 */
  serviceUid: string;
}

export function getAllServiceOnboardedUsers(http: HttpClient, rootUrl: string, params: GetAllServiceOnboardedUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OnboardedUser>>> {
  const rb = new RequestBuilder(rootUrl, getAllServiceOnboardedUsers.PATH, 'get');
  if (params) {
    rb.path('serviceUid', params.serviceUid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<OnboardedUser>>;
    })
  );
}

getAllServiceOnboardedUsers.PATH = '/custom/onboarding/service/{serviceUid}/users';
